import { DraftContact } from 'models/Contact';
import {
  AddContactsPeopleTableKeys,
  CHECKBOX_COLUMNS,
  REQUIRED_COLUMNS,
  TABLE_COLUMNS,
} from './components/ManageContactTableCells/data';
import {
  addMissingRequiredFields,
  checkIsValidEmail,
  checkIsValidName,
  getArrayLength,
} from 'utils';
import { getIsValidPhone, getPhone } from 'phoneNumberUtils';

export const checkIfColumnIsValid = (column: string) =>
  TABLE_COLUMNS.includes(column as AddContactsPeopleTableKeys);

export const checkIfColumnIsCheckbox = (column: string) =>
  CHECKBOX_COLUMNS.includes(column);

export const checkIfCanProcessColumn = (column: string) =>
  checkIfColumnIsValid(column) && !checkIfColumnIsCheckbox(column);

export const checkHasEveryRequiredColumn = (columns: string[]) =>
  REQUIRED_COLUMNS.every((col) => columns.includes(col));

export const addMissingRequiredFieldsToContact = (contact: DraftContact) =>
  addMissingRequiredFields(REQUIRED_COLUMNS, contact) as DraftContact;

export const checkIsContactInvalid = (contact: DraftContact) => {
  const { email, firstName, lastName } = contact;

  return (
    !checkIsValidEmail(email) ||
    !checkIsValidName(firstName) ||
    !checkIsValidName(lastName)
  );
};

export const checkAreAllRequiredFieldsValid = (contacts: DraftContact[]) =>
  !contacts.some(checkIsContactInvalid);

export const getInvalidContactsCount = (contacts: DraftContact[]) =>
  getArrayLength(contacts.filter(checkIsContactInvalid));

export const checkHasInvalidOptionalValues = (contact: DraftContact) => {
  const { phoneNumber } = contact;

  return !!phoneNumber && !getIsValidPhone(getPhone(phoneNumber));
};

export const checkIsPhoneNumberValid = (phoneNumber?: string) =>
  !!phoneNumber && getIsValidPhone(getPhone(phoneNumber));

export const getInvalidOptionalContactsCount = (contacts: DraftContact[]) =>
  getArrayLength(contacts.filter(checkHasInvalidOptionalValues));

export const prepareValuesForApi = (
  contacts: DraftContact[],
): Partial<DraftContact>[] =>
  contacts.map(({ _id, phoneNumber, ...rest }) => ({
    ...Object.fromEntries(
      Object.entries(rest).filter(([key]) => checkIfColumnIsValid(key)),
    ),
    ...(checkIsPhoneNumberValid(phoneNumber)
      ? { phoneNumber: String(phoneNumber) }
      : {}),
  }));
